export const OAUTH_PROVIDERS = ["google", "apple"] as const;

export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];

/**
 * Steps of the shared auth flow. `email` is the common entry point; from there
 * an existing account continues with `password` or `linked-account`, a new one
 * with `create-password` and `verify-code`, and a forgotten password with
 * `reset-code` and `reset-password`.
 */
export type AuthStep =
  | "email"
  | "password"
  | "linked-account"
  | "create-password"
  | "verify-code"
  | "reset-code"
  | "reset-password";

/** Reason why the password step is shown, which drives its header copy. */
export type PasswordStepVariant = "default" | "unlinked-account";
